/* eslint-disable react-refresh/only-export-components */
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
    'inline-flex items-center text-center rounded-md border p-1.5 text-[0.75rem] uppercase truncate font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'rounded-full font-body border-transparent bg-primary text-primary-foreground',
                secondary: 'rounded-full font-body border-transparent bg-secondary text-secondary-foreground',
                destructive: 'rounded-full font-body border-transparent bg-primary text-white px-3 py-1',
                outline: 'rounded-full font-body text-primary border-primary text-center px-3 py-1',
                active: 'rounded-full font-body bg-accent text-white border-transparent text-center uppercase',
                completed: 'rounded-full font-body bg-success text-white border-transparent text-center uppercase  px-3 py-1',
                not_completed:
                    'rounded-full font-body bg-text-light text-white border-transparent text-center uppercase px-3 py-1',
                attempt: 'rounded-full font-body border-neutral-300 bg-none text-neutral-500 text-center uppercase px-3 py-1',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
);

function Badge({ className, variant, ...props }) {
    return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
